import { render } from "./StrokedRoundedLinkIcon.vue?vue&type=template&id=fed5e618"
import script from "./StrokedRoundedLinkIcon.vue?vue&type=script&lang=js"
export * from "./StrokedRoundedLinkIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__